
export default function useRequiredFieldsFilled(values) {
  if (!values.name) {
    return false;
  }
  return true;
};
